if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"OP-WRAPPER","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(99[18]|121|249|288|8)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}